export const Pill_Elements = {
    Pill_Container_Root: "pill-container-",
    Pill_Value_Root: "pill-value-"
};
